// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-content .loading {
  position: absolute;
  top: 0;
  left: 361px;
  width: calc(100% - 370px);
  height: 100%;
  background: rgb(255, 255, 255);
  z-index: 199;
}

.content-business-culture .finishedCultureBtn {
  background: none;
  border: none;
  border-radius: 0;
  padding: 0px;
}
.content-business-culture .finishedCultureBtn:hover {
  background: none;
}
.content-business-culture .finishedCultureBtn:focus {
  background: none;
}
.content-business-culture .type {
  font-weight: bold;
}
.content-business-culture .type.tradicional {
  color: #38364b;
}
.content-business-culture .type.colaborativa {
  color: #2be7c8;
}
.content-business-culture .type.disruptiva {
  color: #41c6ff;
}
.content-business-culture .type.comercial {
  color: #7a6be6;
}
.content-business-culture .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 5px;
  margin: 0 10px;
  display: flex;
  align-items: center;
}
.content-business-culture .icon svg {
  fill: white;
  width: 100%;
}
.content-business-culture h3, .content-business-culture h4 {
  text-align: center;
}
.content-business-culture p {
  font-size: 20px;
}
.content-business-culture input {
  width: 100%;
  border-radius: 12px;
  border-color: #dbdbdb;
}
.content-business-culture button {
  border-radius: 50rem;
  padding: 8px 15px;
  border: none;
  background: linear-gradient(45deg, #40c3fe 0%, #32d7d9 85%);
  color: white;
  display: flex;
}
.content-business-culture .icon-btn-download {
  margin-right: 5px;
}
.content-business-culture .icon-btn-send {
  transform: rotateZ(-45deg) translateY(-5px);
}
.content-business-culture .content-icons-business-culture {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: flex-start;
}
.content-business-culture .content-icons-business-culture hr {
  position: absolute;
  width: 100%;
  border: none;
  border-top: 1px solid;
  margin-top: 25px;
  z-index: 1;
}
.content-business-culture .content-icons-business-culture .icon-b {
  width: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content-business-culture .content-icons-business-culture .icon-b span {
  text-align: center;
}
.content-business-culture .content-icons-business-culture .icon-b .icon-border {
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  background: #dbdbdb;
  z-index: 2;
  border: 3px solid #dbdbdb;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-business-culture .content-icons-business-culture .icon-b .icon-border svg {
  fill: #3b3b3b;
}
.content-business-culture .content-icons-business-culture .active .icon-border {
  border: 3px solid #7b6be4;
  background: white;
}
.content-business-culture .content-icons-business-culture .finished .icon-border {
  border: 3px solid;
  background: #353535;
}
.content-business-culture .content-icons-business-culture .finished .icon-border svg {
  fill: white;
}
.content-business-culture .cursor-pointer {
  cursor: pointer;
}
.content-business-culture ul {
  padding: 0;
  margin-top: 20px;
}
.content-business-culture ul li {
  list-style: none;
  margin: 0 10px;
  text-align: center;
}

.popoverCulture {
  padding: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Views/Culture/businessCulture.sass"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,yBAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;AADR;;AAII;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AADR;AAEQ;EACI,gBAAA;AAAZ;AACQ;EACI,gBAAA;AACZ;AACI;EACI,iBAAA;AACR;AACQ;EACI,cAAA;AACZ;AAAQ;EACI,cAAA;AAEZ;AADQ;EACI,cAAA;AAGZ;AAFQ;EACI,cAAA;AAIZ;AAFI;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAIR;AAFQ;EACI,WAAA;EACA,WAAA;AAIZ;AAFI;EACI,kBAAA;AAIR;AAFI;EACI,eAAA;AAIR;AAFI;EACI,WAAA;EACA,mBAAA;EACA,qBAAA;AAIR;AAFI;EACI,oBAAA;EACA,iBAAA;EACA,YAAA;EACA,2DAAA;EACA,YAAA;EACA,aAAA;AAIR;AAFI;EACI,iBAAA;AAIR;AAFI;EACI,2CAAA;AAIR;AAFI;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;AAIR;AAFQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;AAIZ;AAFQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAIZ;AAFY;EACI,kBAAA;AAIhB;AAFY;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIhB;AAFgB;EACI,aAAA;AAIpB;AAFQ;EACI,yBAAA;EACA,iBAAA;AAIZ;AAFQ;EACI,iBAAA;EACA,mBAAA;AAIZ;AAFY;EACI,WAAA;AAIhB;AAFI;EACI,eAAA;AAIR;AAFI;EACI,UAAA;EACA,gBAAA;AAIR;AAFQ;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;AAIZ;;AAHA;EACI,aAAA;AAMJ","sourcesContent":[".loading-content\n    & .loading\n        position: absolute\n        top: 0\n        left: 361px\n\n        width: calc(100% - 370px)\n        height: 100%\n        background: rgba(255,255,255,1)\n        z-index: 199\n\n.content-business-culture\n    & .finishedCultureBtn\n        background: none\n        border: none\n        border-radius: 0\n        padding: 0px\n        &:hover\n            background: none\n        &:focus\n            background: none\n\n    & .type\n        font-weight: bold\n\n        &.tradicional\n            color: #38364b\n        &.colaborativa\n            color: #2be7c8\n        &.disruptiva\n            color: #41c6ff\n        &.comercial\n            color: #7a6be6\n\n    & .icon\n        background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n        width: 50px\n        height: 50px\n        border-radius: 50rem\n        padding: 5px\n        margin: 0 10px\n        display: flex\n        align-items: center\n\n        & svg\n            fill: white\n            width: 100%\n\n    & h3, h4\n        text-align: center\n\n    & p\n        font-size: 20px\n\n    & input\n        width: 100%\n        border-radius: 12px\n        border-color: #dbdbdb\n\n    & button\n        border-radius: 50rem\n        padding: 8px 15px\n        border: none\n        background: linear-gradient(45deg,#40c3fe 0%, #32d7d9 85%)\n        color: white\n        display: flex\n\n    & .icon-btn-download\n        margin-right: 5px\n\n    & .icon-btn-send\n        transform: rotateZ(-45deg) translateY(-5px)\n\n    & .content-icons-business-culture\n        display: flex\n        justify-content: space-between\n        position: relative\n        align-items: flex-start\n\n        & hr\n            position: absolute\n            width: 100%\n            border: none\n            border-top: 1px solid\n            margin-top: 25px\n            z-index: 1\n\n        & .icon-b\n            width: 150px\n            display: flex\n            flex-direction: column\n            align-items: center\n\n            & span\n                text-align: center\n\n            & .icon-border\n                width: 50px\n                height: 50px\n                border-radius: 50rem\n                background: #dbdbdb\n                z-index: 2\n                border: 3px solid #dbdbdb\n                display: flex\n                justify-content: center\n                align-items: center\n\n                & svg\n                    fill: #3b3b3b\n\n        & .active .icon-border\n            border: 3px solid #7b6be4\n            background: white\n\n        & .finished .icon-border\n            border: 3px solid\n            background: #353535\n\n            & svg\n                fill: white\n\n    & .cursor-pointer\n        cursor: pointer\n\n    & ul\n        padding: 0\n        margin-top: 20px\n\n        & li\n            list-style: none\n            margin: 0 10px\n            text-align: center\n.popoverCulture\n    padding: 15px"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
